import { Component, computed, inject, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SmartInputEntityComponent } from '../smart-input-entity/smart-input-entity.component';
import { WorkPackagePriorityPickerHandler } from '../smart-input-entity/wp-priority-picker.handler';
import { BaseFeatureDto, WorkPackagePriorityDto } from '@api/backend-connector/models';
import { WPPriorityBadgeComponent } from 'src/app/components/wp-card/wp-priority-badge/wp-priority-badge.component';
import { TemplateDirective } from 'src/app/directives/template.directive';
import { WorkPackagePrioritiesService } from 'src/app/services/work-package-priority.service';
import { cast } from 'src/app/utils';

export type WPPriorityPickable = Pick<WorkPackagePriorityDto, 'id' | 'name' | 'color' | 'icon'> | BaseFeatureDto;

@Component({
  selector: 'app-wp-priority-picker',
  templateUrl: './wp-priority-picker.component.html',
  styleUrl: './wp-priority-picker.component.scss',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TemplateDirective,
    TranslateModule,
    WPPriorityBadgeComponent,
    SmartInputEntityComponent,
  ],
})
export class WPPriorityPickerComponent {
  private readonly workPackagePrioritiesService = inject(WorkPackagePrioritiesService);

  readonly control = input.required<FormControl<WPPriorityPickable | null | undefined>>();
  readonly placeholder = input('');
  readonly resetValue = input<WPPriorityPickable | undefined>(undefined);

  readonly workPackagePickerHandler = computed(() => {
    void this.resetValue();
    return new WorkPackagePriorityPickerHandler(this.workPackagePrioritiesService);
  });

  readonly cast = cast<WPPriorityPickable>;
}
